var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"billet-step2-container"},[_c('bank-register-form',{attrs:{"is-pristine":true},on:{"onSubmit":function($event){return _vm.$emit('onNext')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }